import classes from './NotFound.module.css';

const NotFound = () => {
  return (
    <div className={classes.notFound}>
      <h1>This page doesn't exist!</h1>
    </div>
  );
};

export default NotFound;
